<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.05" height="21.192" viewBox="0 0 24.05 21.192">
    <g transform="translate(-1100.412 -579.654)">
      <g>
        <path
          d="M1124.018,600.846h-23l.037-.534a44.765,44.765,0,0,1,1.46-8.671l.661.03.253-.144a5.043,5.043,0,0,0,1.234.847c.767.443,2.307-.3,3.116-.8l-1.143-2.708,1.069.38a59.265,59.265,0,0,1,6.075,2.545,24.947,24.947,0,0,0,5.008,1.563,18.952,18.952,0,0,1,4.3,1.352c2.237,1.256,1.082,5.584,1.032,5.767Zm-21.922-1h21.147c.268-1.231.517-3.61-.647-4.264a18.651,18.651,0,0,0-4.038-1.251,25.527,25.527,0,0,1-5.219-1.639c-1.587-.771-3.229-1.478-4.89-2.1l.575,1.361-.332.232c-.3.2-2.923,1.989-4.526,1.059-.376-.217-.665-.4-.888-.554a43.777,43.777,0,0,0-1.187,7.156Z"
        />
        <rect
          width="22.564"
          height="1"
          transform="translate(1101.596 597.392)"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(1110.801 593.82) rotate(-60.477)"
        />
        <rect
          width="2.484"
          height="1"
          transform="translate(1112.895 594.544) rotate(-59.203)"
        />
      </g>
      <path
        d="M1102,587.747a.493.493,0,0,1-.277-.084.5.5,0,0,1-.206-.544l.534-2.016-1.46-1.246a.5.5,0,0,1,.279-.878l1.881-.171.622-1.815a.5.5,0,0,1,.927-.048l.86,1.86,1.869.174a.5.5,0,0,1,.26.893l-1.6,1.236.633,1.987a.5.5,0,0,1-.783.547l-1.609-1.25-1.626,1.252A.505.505,0,0,1,1102,587.747Zm.144-3.88.8.679a.5.5,0,0,1,.159.509l-.239.9.768-.591a.5.5,0,0,1,.611,0l.641.5-.25-.784a.5.5,0,0,1,.171-.548l.872-.674-.892-.083a.5.5,0,0,1-.408-.288l-.458-.99-.323.942a.5.5,0,0,1-.428.336Zm.975-.591h0Z"
      />
      <path
        d="M1110,586.747a.493.493,0,0,1-.277-.084.5.5,0,0,1-.206-.544l.534-2.016-1.46-1.246a.5.5,0,0,1,.279-.878l1.881-.171.622-1.815a.5.5,0,0,1,.447-.337.507.507,0,0,1,.48.289l.86,1.86,1.869.174a.5.5,0,0,1,.26.893l-1.6,1.236.633,1.987a.5.5,0,0,1-.783.547l-1.609-1.25-1.626,1.252A.505.505,0,0,1,1110,586.747Zm.144-3.88.8.679a.5.5,0,0,1,.159.509l-.239.9.768-.591a.5.5,0,0,1,.611,0l.641.5-.25-.784a.5.5,0,0,1,.171-.548l.872-.674-.892-.083a.5.5,0,0,1-.408-.288l-.458-.99-.323.942a.5.5,0,0,1-.428.336Zm.975-.591h0Z"
      />
      <path
        d="M1118,587.747a.493.493,0,0,1-.277-.084.5.5,0,0,1-.206-.544l.534-2.016-1.46-1.246a.5.5,0,0,1,.279-.878l1.881-.171.622-1.815a.5.5,0,0,1,.927-.048l.86,1.86,1.869.174a.5.5,0,0,1,.26.893l-1.6,1.236.633,1.987a.5.5,0,0,1-.783.547l-1.609-1.25-1.626,1.252A.505.505,0,0,1,1118,587.747Zm.144-3.88.8.679a.5.5,0,0,1,.159.509l-.239.9.768-.591a.5.5,0,0,1,.611,0l.641.5-.25-.784a.5.5,0,0,1,.171-.548l.872-.674-.892-.083a.5.5,0,0,1-.408-.288l-.458-.99-.323.942a.5.5,0,0,1-.428.336Zm.975-.591h0Z"
      />
    </g>
  </svg>
</template>
